import RouterHelper from "@/helpers/router.helper.js"
export default {
  methods: {
    pushI18nRoute(route) {
      // console.log("pushI18nRoute", RouterHelper.getI18nRoute(route))
      this.$router.push(RouterHelper.getI18nRoute(route))
    },
  },
}
